export const formatterNumber = (value: string | number | undefined) => {
    if (!value) return '';
    const stringValue = String(value).replace('.', ',');
    const [integer, decimal] = stringValue.split(',');

    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return decimal !== undefined ? `${formattedInteger},${decimal}` : formattedInteger;
};

  
export const parserNumber = (value: string | undefined) => {
    if (!value) return 0;

    const numericValue = value.replace(/\./g, "").replace(",", ".");
    return parseFloat(numericValue) || 0;
};